import React from 'react'
import { Input } from '@/shared/ui/Input'

type Props = {
  value: string
  onChange: (v: string) => void
  className?: string
  placeholder?: string
}

// Componente simples e reutilizável para busca local na lista de fechadas
export default function ClosedOpportunitiesSearch({ value, onChange, className, placeholder }: Props) {
  const id = React.useId()
  return (
    <div className={className}>
      <Input
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder ?? 'Buscar por nome ou sigla (ex.: Bitcoin ou BTCUSDT)'}
        aria-label="Buscar oportunidades encerradas"
      />
    </div>
  )
}

